const locale = {
	// #region User Dashboard
	WELCOME: 'Bentornato',
	PROFILE_LINK: 'Vai al tuo profilo ',

	PERSONAL_AREA: 'Area personale',

	USER_LOGIN_EMAIL: 'Indirizzo Mail Login',
	USER_RECRUITMENT_DATE: 'Data assunzione',
	RIGHTSIDEBAR_INFO_SECTION: 'Informazioni',
	RIGHTSIDEBAR_NOTIFICATION_SECTION: 'Notifiche',
	RIGHTSIDEBAR_GROUPS_SECTION: 'Gruppi',
	RIGHTSIDEBAR_SETTINGS_SECTION: 'Impostazioni',

	USER_MENU_EDIT_PROFILE: 'Modifica profilo',
	USER_MENU_ADMIN_AREA: "Vai all'area Admin",
	USER_MENU_CHANGE_PASSWORD: 'Modifica password',

	DIALOG_USERPROFILE_AVATAR: 'Avatar',
	DIALOG_USERPROFILE_SECTION_PERCEPTIVE_TITLE: 'Modifica informazioni Account Perceptive',
	DIALOG_USERPROFILE_SECTION_PROFILE_TITLE: 'Modifica informazioni profilo',
	// #endregion

	// #region Pages title and helper texts
	MODULE_COMMUNICATIONS_TITLE: 'Comunicazioni',
	MODULE_DOCS_TITLE: 'Documenti',
	MODULE_REQUESTS_TITLE: 'Segnalazioni',
	MODULE_LEAVE_TITLE: 'Permessi',
	MODULE_AVAILABILITY_TITLE: 'Disponibilità Utenti',
	MODULE_AVAILABILITY_GROUP_TITLE: 'Disponibilità Membri',
	PAGE_SUPERVISOR_LEAVE_TITLE: 'Supervisore - Permessi',
	PAGE_SUPERVISOR_CALENDAR_TITLE: 'Supervisore - Calendario',
	PAGE_GROUP_INFO_TITLE: 'Informazioni',
	// #endregion

	// #region Calendar texts
	CALENDAR_BUTTON_REJECT: 'Rifiuta',
	CALENDAR_BUTTON_ACCEPT: 'Accetta',
	CALENDAR_BUTTON_BACK: 'Indietro',
	CALENDAR_DIALOG_REJECT_TITLE: 'Rifiuta',

	CALENDAR_TOOLTIP_TODAY: 'Oggi',
	CALENDAR_TOOLTIP_DAY: 'Giorno',
	CALENDAR_TOOLTIP_WEEK: 'Settimana',
	CALENDAR_TOOLTIP_MONTH: 'Mese',
	CALENDAR_TOOLTIP_PREVIOUS: 'Precedente',
	CALENDAR_TOOLTIP_NEXT: 'Successivo',
	// #endregion

	// #region User Availability texts
	USER_AVAILABLE: 'Reperibile',
	USER_AWAY: 'Trasferta',
	USER_NOT_AVAILABLE: 'Non Reperibile',
	SMARTWORKING: 'Smartworking',
	USER_REDUCED_AVAILABILITY: 'Reperibilità Ridotta',
	SATURDAY: 'Sabato',
	SUNDAY: 'Domenica',
	CLOSING_DAY: 'Giorno di chiusura',
	// #endregion

	// #region tabs description
	LEAVE_HEADER_PAGE_DESCRIPTION:
		'In questa sezione puoi richiedere un permesso per malattia, ferie, visita medica, donazione di sangue o lutto. Puoi anche visionare lo stato dei permessi già presentati.',
	REQUESTS_HEADER_PAGE_DESCRIPTION:
		'In questa sezione puoi controllare lo stato delle tue segnalazioni, richieste generiche, suggerimenti e non conformità. Puoi anche utilizzare il pulsante "NUOVO" per aggiungerne una nuova.',
	// #endregion

	// #region Misc
	PAGE_GROUP_INFO_MEMBERS: 'Membri',

	NO_NOTIFICATIONS: 'Non hai notifiche da leggere.',

	NO_COMMUNICATIONS_TITLE: 'Nessuna Comunicazione presente',
	NO_COMMUNICATIONS_DESCRIPTION: "Non sono disponibili Comunicazione attive visibili per l'Utente corrente.",

	NO_DOCSFOLDERS_TITLE: 'Nessuna Cartella Documenti presente',
	NO_DOCSFOLDERS_DESCRIPTION: "Non sono disponibili Cartelle Documenti visibili per l'Utente corrente."
	// #endregion
};

export default locale;
